import { css } from '@emotion/react';
import { semantic_colors, colors } from '../../foundation';
import { getAutoColorCode } from '../../styles';

const menu_group_container_vertical_padding = 16;
const menu_group_container_gap = 2;
const menu_group_container_border_width = 1;

export const menu_base_css = css`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const menu_item_base_css = css`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  background-color: ${semantic_colors.background.surface};
  transition: all 0.1s linear;
  cursor: pointer;
  &:hover {
    background-color: ${colors.gray10};
  }
  &:focus {
    background-color: ${colors.gray20};
  }
  &:active {
    background-color: ${colors.gray20};
  }
`;

export const menu_group_item_css = css`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  border-radius: 8px;
  background-color: transparent;
  color: ${semantic_colors.content.primary};
  transition: all 0.1s linear;
  cursor: pointer;
  &:hover {
    background-color: ${getAutoColorCode(colors.gray10).hover};
  }
  &:focus {
    background-color: ${getAutoColorCode(colors.gray10).pressed};
  }
  &:active {
    background-color: ${getAutoColorCode(colors.gray10).pressed};
  }
`;

export const menu_group_container_css = css`
  box-sizing: border-box;
  overflow: hidden;
  background-color: ${colors.gray10};
  border-top: ${menu_group_container_border_width}px solid ${semantic_colors.border.primary};
  border-bottom: ${menu_group_container_border_width}px solid ${semantic_colors.border.primary};
`;

export const menu_group_list_css = css`
  display: flex;
  flex-direction: column;
  gap: ${menu_group_container_gap}px;
  box-sizing: border-box;
  padding: ${menu_group_container_vertical_padding}px 8px;
`;

export function getMenuGroupStyles(dense: boolean) {
  return dense
    ? {
        height: 30,
        padding: '6px 16px',
      }
    : {
        height: 53,
        padding: '16px 32px 16px 48px',
      };
}

export function getMenuGroupContainerHeight(dense: boolean, childCount: number) {
  const child_height = getMenuGroupStyles(dense).height;
  const gap_height = Math.max(childCount - 1, 0) * menu_group_container_gap;

  return (
    childCount * child_height +
    gap_height +
    menu_group_container_vertical_padding * 2 +
    menu_group_container_border_width * 2
  );
}

export function getMenuItemStyles(dense: boolean) {
  return dense
    ? {
        height: 38,
        padding: '10px 20px',
      }
    : {
        height: 62,
        padding: '20px',
      };
}
